module.exports = __webpack_public_path__ + "img/1960_uk.f6800e2c.svg";